<template>
  <div class="">
    <div
      v-if="forbiddenMessage"
      style="
        margin: 20px 0;
        text-align: center;
        font-size: 18px;
        color: #001831;
      "
      v-html="forbiddenMessage"
    ></div>
    <div class="contentForm" v-else>
      <h2 class="title">{{ $t("remoteHands.titleStep1") }}</h2>
      <p class="subTitle">{{ $t("remoteHands.subTitleStep1") }}</p>

      <p class="error" v-if="error">
        {{ $t("remoteHands.titleStep1") }} {{ $t("checkCoverage.isRequired") }}
      </p>

      <div class="space"></div>

      <div class="mdl-grid padding0">
        <div class="mdl-cell mdl-cell--12-col" style="margin-left: 0">
          <div v-for="(act, keyAct) in activity" :key="keyAct">
            <p class="labelTwo">{{ act.name_group }}</p>
            <div class="contentActivity">
              <div
                v-for="(item, keyItem) in act.list || []"
                :key="keyItem"
                :class="['itemActivity-' + keyAct + '-' + keyItem]"
                class="itemActivity"
                @click="
                  setActivity(item, keyAct + '-' + keyItem, act.name_group)
                "
                :style="[
                  'background: transparent linear-gradient(121deg, ' +
                    (act.color?.[0] ?? '#FFFCF4') +
                    ' 0%, ' +
                    (act.color?.[1] ?? '#D2DEEA') +
                    ' 100%) 0% 0% no-repeat padding-box;',
                ]"
              >
                <p>{{ item.name }}</p>
              </div>
            </div>
            <br /><br />
          </div>
        </div>
      </div>

      <MyLoading :viewLoader="this.viewLoader" type="" />

      <div class="cdlContentButtonSingle">
        <div class="cdlButtonSingle green" id="nextStep" @click="goNext()">
          {{ $t("checkCoverage.stepsButtonOne") }}
        </div>
      </div>
      <p class="deleteOrder" @click="cancelOrder()">
        {{ $t("remoteHands.deleteTicket") }}
      </p>
    </div>
  </div>
</template>

<script>
import MyLoading from "@/components/MyLoading.vue";

export default {
  name: "ActivityRh",
  components: {
    MyLoading,
  },
  props: {
    stepData: {
      type: Object,
      required: true,
    },
    wizardData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: {
        activity_type: "",
        activity_group: "",
      },
      activity: [],
      error: false,
      viewLoader: false,
      forbiddenMessage: "",
    };
  },
  methods: {
    getStep(type) {
      let step = this.stepData;
      if (type == "before") {
        return step - 1;
      }
      return step + 1;
    },
    async goNext() {
      window.scrollTo(0, 0);
      if (this.fields.activity_type != "") {
        this.$emit("goNext");
        return;
      }
      this.error = true;
      return;
    },
    setActivity(value, index, nameGroup) {
      if (!value) return;
      this.error = false;
      Object.assign(this.fields, {
        activity_type: value,
        activity_group: nameGroup,
      });
      this.$emit("update", this.fields);

      let itemActivity = document.getElementsByClassName("itemActivity");
      Object.entries(itemActivity).forEach((elm) => {
        elm[1].classList.remove("active");
      });

      if( document.getElementsByClassName("itemActivity-" + index)[0] ) {
        document
          .getElementsByClassName("itemActivity-" + index)[0]
          .classList.add("active");
        window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
      }

    },
    cancelOrder() {
      return this.$router.push({ name: "RemoteHandsList" + this.$i18n.locale });
    },
    async checkColocationAccess(headers) {
      try {
        const response = await this.axios.get(
          window.VUE_APP_MISTRA_URL +
            "assets/v1/has-assets/colocation",
          { headers }
        );

        const hasAssets = !!(response?.data?.hasAssets);

        if (!hasAssets) {
          this.forbiddenMessage = this.$t("noSolutionsServices.colocation");
        }

        return hasAssets;
      } catch (error) {
        const status = error?.response?.status ?? error?.request?.status;

        if (status === 403) {
          this.forbiddenMessage = this.$t("noSolutionsServices.colocation");
          return false;
        }

        console.error("Error checking colocation assets:", error);
        return true;
      }
    },
  },
  async activated() {
    window.scrollTo(0, 0);

    this.forbiddenMessage = "";
    this.viewLoader = false;

    Object.assign(this.fields, {
      activity_type: this.wizardData.activity_type,
    });

    if (this.fields.activity_type == "") {
      let itemActivity = document.getElementsByClassName("itemActivity");
      Object.entries(itemActivity).forEach((elm) => {
        elm[1].classList.remove("active");
      });
    }

    let he = {
      Accept: "application/json",
      Authorization: "Bearer " + this.$keycloak.idToken,
    };

    const hasColocation = await this.checkColocationAccess(he);

    if (!hasColocation) {
      this.activity = [];
      this.viewLoader = true;
      return;
    }

    this.axios
      .get(
        window.VUE_APP_MISTRA_URL +
          "tickets/v1/service-rh-details",
        { headers: he }
      )
      .then((response) => {
        this.activity = Array.isArray(response.data) ? response.data : [];
        if (this.wizardData.fromAccessDc) {
          // voce "accesso al magazzino": cercata in entrambe le lingue, preselezionata solo se presente nel contratto
          const warehouseNames = [
            "Access to the warehouse accompanied by CDLAN",
            "Accesso al deposito merce accompagnato da CDLAN",
          ];
          const indexOne = this.activity.findIndex((group) => group.name_group === "B - Basic");
          const group = this.activity[indexOne];
          const indexTwo = (group?.list || []).findIndex((item) => warehouseNames.includes(item.name));
          if (indexTwo !== -1) {
            this.setActivity(group.list[indexTwo], indexOne + "-" + indexTwo, group.name_group);
            this.viewLoader = true;
            this.$emit("goNext");
            return;
          }
        }
        this.viewLoader = true;
      })
      .catch((err) => {
        const status = err?.response?.status;

        if (status === 403) {
          this.forbiddenMessage = this.$t("noSolutionsServices.colocation");
        } else {
          console.error(err);
        }

        this.activity = [];
        this.viewLoader = true;
      });
  },
};
</script>
